const initialState = {
  simType: 'SIM_CARD',
  eID: ''
}

const SimDataModule = {
  namespaced: true,
  state: initialState,
  getters: {
    simData: state => {
      return state
    },
    simType: state => {
      return state.simType
    }
  },
  mutations: {
    setSimData (state, { simType, eID = '' }) {
      state.simType = simType
      state.eID = eID
    },
    setSimType (state, simType) {
      state.simType = simType
    },
    resetState (state) {
      Object.assign(state, initialState)
    }
  }
}

export default SimDataModule
